import { useState, forwardRef, useImperativeHandle } from "react";
import { ButtonCell } from "@telegram-apps/telegram-ui";
import { useTranslation } from "react-i18next";
import { Popup } from "antd-mobile";
import { miniApp } from "@telegram-apps/sdk-react";
import { IconTipL } from "~/components/index.tsx";
import { SafeAreaBottom } from "~/components/widget";

export type ModalSessionRef = { open: () => void };

const ModalSession: React.ForwardRefRenderFunction<ModalSessionRef> = (
    _,
    ref
) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => {
            setOpen(true);
        },
    }));

    const clickEvent = () => {
        setOpen(false);
        miniApp.close();
    };

    return (
        <Popup
            visible={open}
            closeOnSwipe={true}
            onClose={() => setOpen(false)}
            bodyClassName="bg-bg_0"
            bodyStyle={{
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
                paddingLeft: "16px",
                paddingRight: "16px",
            }}
        >
            {/*<div className='flex justify-end items-center h-[60px]'>
                <img src={closeSvg} width={28} className='cursor-pointer' onClick={() => setOpen(false)} />
            </div>*/}
            <div className="flex flex-col items-center justify-center mt-[20px] pb-[44px]">
                <IconTipL className="text-text_3 text-[56px]" />
                <div className="text-text_1 text-h6 font-Semibold text-center my-[12px]">
                    {t("session_expired_title")}
                </div>
                <div className="text-text_2 text-body2 font-Regular text-center">
                    {t("session_expired_desc")}
                </div>
            </div>
            <ButtonCell
                className="w-full px-0 block bg-bg_0 py-0 my-2 h-auto overflow-hidden"
                onClick={clickEvent}
            >
                <div className="w-full h-[54px] rounded-[12px] bg-Orange flex justify-center items-center text-white text-h6 font-Semibold">
                    {t("close_dex")}
                </div>
            </ButtonCell>
            <SafeAreaBottom />
        </Popup>
    );
};

export default forwardRef(ModalSession);
